import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/labor-core/_packages/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
